<div class="main-content">
  <app-header [title]="(isEdit ? 'LEARNING_FORM.EDIT_TITLE' : 'LEARNING_FORM.CREATE_TITLE') | translate" />
  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'article'"
          [iconColor]="'#e30714'"
          [iconHeight]="'32px'"
          >
          @if (!isLoading) {
            <div class="learning-container">
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container learning-form d-flex flex-column">
                <div class="form-section learning-config-section w-100">
                  <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/article.svg" alt="article" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{ 'LEARNING_FORM.LEARNING_CONFIGURATION' | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="title">{{ 'LEARNING_FORM.TITLE' | translate }}*</label>
                        <app-icam-input
                          label="{{ 'LEARNING_FORM.TITLE' | translate }}"
                          inputId="title"
                          [isSlim]="true"
                          inputType="text"
                          formControlName="title"
                          [ngClass]="isLight ? 'light' : 'dark'"
                          [required]="true"
                          />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="content">{{ 'LEARNING_FORM.CONTENT' | translate }}</label>
                        <angular-editor
                          id="content"
                          formControlName="content"
                          [config]="editorConfig"
                          placeholder="{{ 'LEARNING_FORM.CONTENT_PLACEHOLDER' | translate }}"
                        ></angular-editor>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="complexity">{{ 'LEARNING_FORM.COMPLEXITY' | translate }}</label>
                        <app-icam-select
                          #complexitySelect
                          [name]="'complexity'"
                          [field]="complexityField"
                          [translateOptions]="false"
                          [disabled]="isLoading"
                          (selectedFilter)="onComplexitySelected($event)"
                        ></app-icam-select>
                        @if (form.get('complexity')?.invalid && form.get('complexity')?.touched) {
                          <div
                            class="invalid-feedback d-block"
                            >
                            {{ 'LEARNING_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="language">{{ 'LEARNING_FORM.LANGUAGE' | translate }}</label>
                        <app-icam-select
                          #languageSelect
                          [name]="'language'"
                          [field]="languageField"
                          [translateOptions]="false"
                          [disabled]="isLoading"
                          (selectedFilter)="onLanguageSelected($event)"
                        ></app-icam-select>
                        @if (form.get('language')?.invalid && form.get('language')?.touched) {
                          <div
                            class="invalid-feedback d-block"
                            >
                            {{ 'LEARNING_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="machineTypes">{{ 'LEARNING_FORM.MACHINE_TYPES' | translate }}*</label>
                        <app-multi-select-autocomplete
                          formControlName="machineTypes"
                          [placeholder]="'LEARNING_FORM.MACHINE_TYPES_PLACEHOLDER' | translate"
                          [options]="typologyOptions"
                          [displayField]="'name'"
                          [filterFields]="['name']"
                          [fetchFn]="fetchTypologies"
                        ></app-multi-select-autocomplete>
                        @if (form.get('machineTypes')?.invalid && form.get('machineTypes')?.touched) {
                          <div
                            class="invalid-feedback d-block"
                            >
                            {{ 'LEARNING_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                    @if (isEdit && _learningId) {
                      <div class="col-12">
                        <div class="input-wrapper">
                          <label for="tags">{{ 'LEARNING_FORM.TAGS' | translate }}</label>
                          <app-learning-tag-input [learningId]="_learningId" formControlName="tags"></app-learning-tag-input>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="preview">{{ 'LEARNING_FORM.PREVIEW' | translate }}*</label>
                        <app-file-input
                          formControlName="preview"
                          [accept]="'image/*'"
                          labelKey="LEARNING_FORM.CHOOSE_PREVIEW_FILE"
                          placeholder="LEARNING_FORM.PREVIEW_PLACEHOLDER"
                          (fileSelected)="onFileInputSelected($event)"
                          (fileRemoved)="removePreviewAttachment()"
                          />
                        @if (form.get('preview')?.touched && !previewAttachment && !existingPreviewAttachment) {
                          <div
                            class="invalid-feedback d-block"
                            >
                            {{ 'LEARNING_FORM.REQUIRED_FIELD' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <app-learning-attachment-input
                          [titleKey]="'FILE_INPUT_HISTORY.VIDEO'"
                          [noFilesKey]="'FILE_INPUT_HISTORY.NO_VIDEOS_UPLOADED'"
                          [learningId]="_learningId"
                          [accept]="'video/*'"
                          [filterByAccept]="true"
                          [downloadProperty]="'attachmentId'"
                          [mediaType]="'video'"
                          (pathsChanged)="onVideoPathsChanged($event)"
                          >
                        </app-learning-attachment-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <app-learning-attachment-input
                          [titleKey]="'FILE_INPUT_HISTORY.IMAGES'"
                          [noFilesKey]="'FILE_INPUT_HISTORY.NO_IMAGES_UPLOADED'"
                          [learningId]="_learningId"
                          [accept]="'image/*'"
                          [filterByAccept]="true"
                          [downloadProperty]="'attachmentId'"
                          [mediaType]="'image'"
                          (pathsChanged)="onImagePathsChanged($event)"
                          >
                        </app-learning-attachment-input>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <app-learning-attachment-input
                          [titleKey]="'FILE_INPUT_HISTORY.DOCUMENTS'"
                          [noFilesKey]="'FILE_INPUT_HISTORY.NO_DOCUMENTS_UPLOADED'"
                          [learningId]="_learningId"
                          [accept]="'.pdf,.doc,.docx'"
                          [filterByAccept]="true"
                          [downloadProperty]="'attachmentId'"
                          [mediaType]="'document'"
                          (pathsChanged)="onDocumentPathsChanged($event)"
                          >
                        </app-learning-attachment-input>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="button-form-submit"
                    [class.disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                    [disabled]="!form.valid || !isAttachmentsValid() || isLoading"
                    >
                    @if (isLoading) {
                      <div class="d-flex justify-content-center">
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                      </div>
                    } @else {
                      {{ isEdit ? ('LEARNING_FORM.UPDATE' | translate) : ('LEARNING_FORM.SAVE' | translate) }}
                    }
                  </button>
                </div>
              </form>
            </div>
          }
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      @if (saveSuccess) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'OK'"
          [iconColor]="'#00A5A9'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit ? 'LEARNING_FORM.UPDATED_LEARNING' : 'LEARNING_FORM.CREATED_LEARNING') | translate }}
            </h1>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteSuccess) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'OK'"
          [iconColor]="'#00A5A9'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ getToggleSuccessTitle() | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ getToggleSuccessDescription() | translate }}
            </p>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (saveError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'KO'"
          [iconColor]="'#e30714'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit ? 'LEARNING_FORM.UPDATE_ERROR' : 'LEARNING_FORM.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{
              (isEdit ? 'LEARNING_FORM.UPDATE_ERROR_DESCRIPTION' : 'LEARNING_FORM.CREATE_ERROR_DESCRIPTION') | translate
              }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <button class="btn btn-primary" (click)="tryAgain()">
              {{ 'COMMON.TRY_AGAIN' | translate }}
            </button>
            <button class="btn btn-outline-secondary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (deleteError) {
        <app-icam-container
          [centralIcon]="true"
          [iconName]="'KO'"
          [iconColor]="'#e30714'"
          [iconHeight]="'60px'"
          >
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ getToggleErrorTitle() | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ getToggleErrorDescription() | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
            <div class="d-flex mt-3 gap-3">
              <button class="btn btn-primary" (click)="tryAgain()">
                {{ 'COMMON.TRY_AGAIN' | translate }}
              </button>
              <button class="btn btn-outline-secondary" (click)="goToList()">
                {{ 'COMMON.RETURN_TO_LIST' | translate }}
              </button>
            </div>
          </div>
        </app-icam-container>
      }

      <div class="form-footer d-flex justify-content-between mt-4">
        @if (!showSuccess && !showError) {
          <div>
            <app-back-button
              class="app-back-button"
              [linkText]="'LEARNING_FORM.BACK_TO_LEARNINGS'"
              (click)="goBack()"
            ></app-back-button>
          </div>
        }
        @if (isEdit && !showSuccess && !showError) {
          <button
            type="button"
            [ngClass]="isLight ? 'btn btn-outline-danger' : 'btn btn-outline-light'"
            (click)="toggleLearningActivation()"
            [class.disabled]="isLoading"
            [disabled]="isLoading"
            >
            @if (isLoading) {
              <div class="d-flex justify-content-center">
                <div class="spinner-border spinner-border-sm" role="status"></div>
              </div>
            } @else {
              {{ getToggleButtonText() | translate }}
            }
          </button>
        }
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
